import { Table } from "reactstrap";
import {  H6 } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";

const ViewSubscriptionSection = ({orgData}:any) => {
    console.log(orgData,"admin");
    const {t}=useTranslation()
    
  return (
    <td>
      <Table className="bill-content w-100">
        <tbody>
        <tr>
      
            <td style={{ width: "21%" }}>
              <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("OrganizationSubscriptionPlan")}</span>
              <H6 style={{ width: "46%" }}>
                {orgData?.subscriptionPlan? orgData?.subscriptionPlan : "Free"} 
              </H6>
            </td>
            <td style={{ width: "21%" }}>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("ExpireyDate")}</span>
              <H6>{orgData.expireyDate? orgData.expireyDate : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("Distributor")}</span>
              <H6>{orgData.distributor? orgData.distributor : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("Franchises")}</span>
              <H6>{orgData.franchise? orgData.franchise : "N/A"}</H6>
            </td>
            <td>
              <span style={{ opacity: "0.8",color:"#757272" }}>{t("AccountType")}</span>
              <H6>{orgData.accountType? orgData.accountType : "Free"}</H6>
             
            </td>
           
          </tr>
          
         
        </tbody>
      </Table>
    </td>
  );
};

export default ViewSubscriptionSection;
